(function () {
  var bar = document.querySelector("[data-brand-story-progress]");
  if (!bar) return;

  var root = document.documentElement;
  var ticking = false;

  function update() {
    var scrollTop = window.scrollY || root.scrollTop || 0;
    var height = root.scrollHeight - root.clientHeight;
    var ratio = height > 0 ? scrollTop / height : 0;
    if (ratio < 0) ratio = 0;
    if (ratio > 1) ratio = 1;
    bar.style.transform = "scaleX(" + ratio + ")";
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      update();
      ticking = false;
    });
  }

  update();
  window.addEventListener("scroll", onScroll, { passive: true });
})();

